export const PackageData = [
  {
    showButton: false,
    showCurrentPackageHeader: false,
    showHeader: false,
    nameKey: 'starter',
    subName: 'xxxxx',
    price: { monthly: '$0', yearly: '$0' },
    info: [
      {
        title: 'Package.management_systems',
        description: [
          { desc: 'Package.up_to_10_dish_publication' },
          { desc: 'Package.1_menu_publication' },
          { desc: 'Package.1_coupon_publication' },
          { desc: 'Package.1_event_publication' },
        ],
      },
      {
        title: 'Package.ordering_system',
        description: [{ desc: 'Package.basic' }],
      },
      {
        title: 'Package.visual_report_and_data_analytics',
        description: [{ desc: 'Package.basic' }],
      },
      { title: 'Package.display_language', description: [{ desc: 'Package.local_language_only' }] },
      {
        title: 'Package.management_account',
        description: [{ desc: 'Package.1_user_account_only' }],
      },
    ],
  },
  {
    showSelectButton: false,
    showButton: false,
    showCurrentPackageHeader: false,
    showHeader: false,
    nameKey: 'pro',
    nameStyle: '#000000',
    buttonStyle: '#000000',
    buttonTextStyle: 'white',
    subName: 'xxxxx',
    price: { monthly: '$49', yearly: '$29' },
    info: [
      {
        title: 'Package.management_systems',
        description: [
          { desc: 'Package.unlimited_dish_publication' },
          { desc: 'Package.5_menu_publication' },
          { desc: 'Package.5_coupon_publication' },
          { desc: 'Package.5_event_publication' },
        ],
      },
      {
        title: 'Package.ordering_system',
        description: [{ desc: 'Package.advanced' }],
      },
      {
        title: 'Package.visual_report_and_data_analytics',
        description: [{ desc: 'Package.advanced' }],
      },
      { title: 'Package.display_language', description: [{ desc: 'Package.up_to_10_languages' }] },
      {
        title: 'Package.management_account',
        description: [{ desc: 'Package.up_to_3_user_accounts' }],
      },
    ],
  },
  {
    showLandingHeader: false,
    showPopularHeader: false,
    showSelectButton: false,
    showButton: false,
    showHeader: false,
    nameKey: 'enterprise',
    nameStyle: '#003566',
    subName: 'xxxxx',
    price: { monthly: '$99', yearly: '$49' },
    info: [
      {
        title: 'Package.management_systems',
        description: [
          { desc: 'Package.unlimited_dish_publication', subDesc: ['Package.custom_dish_tags'] },
          {
            desc: 'Package.unlimited_menu_publication',
            subDesc: ['Package.custom_menu_design', 'Package.menu_setup_assistance'],
          },
          {
            desc: 'Package.unlimited_deal_publication',
            subDesc: ['Package.promote_through_global_commercial_distribution_network'],
          },
          {
            desc: 'Package.unlimited_event_publication',
            subDesc: ['Package.promote_through_multinational_kol_network'],
          },
        ],
      },
      {
        title: 'Package.ordering_system',
        description: [{ desc: 'Package.comprehensive' }],
      },
      {
        title: 'Package.visual_report_and_data_analytics',
        description: [{ desc: 'Package.comprehensive' }],
      },
      { title: 'Package.display_language', description: [{ desc: 'Package.up_to_10_languages' }] },
      {
        title: 'Package.management_account',
        description: [{ desc: 'Package.more_than_3_user_accounts' }],
      },
      {
        title: 'Package.first_mover_invitation',
        description: [
          { desc: 'Package.venue_hire_management', showTag: true },
          { desc: 'Package.online_ordering_system', showTag: true },
          { desc: 'Package.staff_management', showTag: true },
        ],
      },
    ],
  },
];

export const MAX_NUMBER_OF_PACKAGE = 3;
